// import React, {Component, Suspense} from 'react';
// import {BrowserRouter, Route, Routes} from 'react-router-dom';
// import {connect} from 'react-redux';
// import Loadable from 'react-loadable';
// import {routes} from "./routes"; 
// import {isUserAuthenticated} from './helpers/authUtils';

// import logo from './logo.svg';
// import './config';
// // import './assets/scss/DefaultTheme.scss'
// import "./assets/scss/_common.scss";


// // Lazy loading and code splitting
// // Derived idea from https://blog.logrocket.com/lazy-loading-components-in-react-16-6-6cea535c0b52

// import Loading from './components/Loading';
// import Loader from './components/Loader';
// const loading = () => <div></div>;
// // All layouts/containers
// const NonAuthLayout = Loadable({
//     loader: () => import('./components/NonAuthLayout'),
//     render(loaded, props) {
//         let Component = loaded.default;
//         return <Component {...props} />;
//     },
//     loading() {
//         return <Loader/>
//     }
// });

// const AuthLayout = Loadable({
//     loader: () => import('./components/AuthLayout'),
//     render(loaded, props) {
//         let Component = loaded.default;
//         return <Component {...props} />;
//     },
//     loading() {
//         return <Loader/>
//     }
// });

// const LoadableExample = Loadable({
//     loader: () => import('./components/AuthLayout'),
//     loading: Loading,
// });

// /**
//  * Exports the component with layout wrapped to it
//  * @param {} WrappedComponent
//  */
// const withLayout = (WrappedComponent) => {
//     const HOC = class extends Component {
//         render() {
//             return <WrappedComponent {...this.props} />;
//         }
//     };

//     return connect()(HOC);
// }
// const NotFound = () => {
//     return(<h1>Not Found</h1>);
// }

// class App extends Component {
//     /**
//      * Returns the layout component based on different properties
//      * @param {*} props
//      */
//     getLayout = (route) => {
//         if (route === 'Register2' || route === 'ContactusPage' || route === 'UserKyc'  ) {
//             return NonAuthLayout;
//         }
//         return AuthLayout;
//         //return isUserAuthenticated() ? AuthLayout : NonAuthLayout;
//     }

//     render() {
//         return (
//             <div className="App">
//                 <BrowserRouter>
//                     <React.Fragment>
//                         <Routes>
//                             {routes.map((route, index) => {
//                                 const Layout = this.getLayout(route.name);
//                                 return (
//                                     <Route
//                                         key={index}
//                                         path={route.path}
//                                         element={
//                                             <Suspense fallback={loading()}>
//                                                 <Layout>
//                                                     <route.component />
//                                                 </Layout>
//                                             </Suspense>
//                                         }
//                                     />
//                                 );
//                             })}
//                             <Route path="*" element={<NotFound />} />
//                         </Routes>
//                     </React.Fragment>
//                 </BrowserRouter>
//             </div>
//         );
//     }
// }

// const mapStateToProps = (state) => {
//     return {
//         isAuthenticated: state.Auth.isAuthenticated
//     }
// }

// export default connect(mapStateToProps, null)(App);












import React, { Component, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { connect } from 'react-redux';
import Loadable from 'react-loadable';
import { routes } from "./routes";
import { isUserAuthenticated } from './helpers/authUtils';
import Userprofile from './pages/Userprofile';

import logo from './logo.svg';
import 'alertifyjs/build/css/alertify.min.css'
import 'alertifyjs/build/css/themes/semantic.min.css'
import './assets/scss/DefaultTheme.scss';
import "./assets/scss/_common.scss";
import 'react-accessible-accordion/dist/fancy-example.css';
import 'react-table/react-table.css'; // Adjust path as per the actual location in node_modules

import { NavigationProvider } from './NavigationContext';

import './config';

// Lazy loading and code splitting -
// Derieved idea from https://blog.logrocket.com/lazy-loading-components-in-react-16-6-6cea535c0b52
import Loading from './components/Loading';
import Loader from './components/Loader/Loader';





const loading = () => <div></div>;

// All layouts/containers
const NonAuthLayout = Loadable({
    loader: () => import('./components/NonAuthLayout'),
    render(loaded, props) {
        let Component = loaded.default;
        return <Component {...props} />;
    },
    loading() {
        return <Loader />
    }
});

const AuthLayout = Loadable({
    loader: () => import('./components/AuthLayout'),
    render(loaded, props) {
        let Component = loaded.default;
        return <Component {...props} />;
    },
    loading() {
        return <Loader />
    }
});

const LoadableExample = Loadable({
    loader: () => import('./components/AuthLayout'),
    loading: Loading,
});

/**
 * Exports the component with layout wrapped to it
 * @param {} WrappedComponent
 */
const withLayout = (WrappedComponent) => {
    const HOC = class extends Component {
        render() {
            return <WrappedComponent {...this.props} />;
        }
    };

    return connect()(HOC);
}
const NotFound = () => {
    return (<h1>Not Found</h1>);
}

class App extends Component {
    /**
     * Returns the layout component based on different properties
     * @param {*} props
     */
    getLayout = (route) => {
        if (route == 'Register2' || route == 'ContactusPage' || route == 'UserKyc') {
            return NonAuthLayout;
        }
        return AuthLayout;
        //return isUserAuthenticated() ? AuthLayout : NonAuthLayout;
    }

    render() {
        return (
            <div className="App">
                {/* <BrowserRouter forceRefresh={false} history={history}> */}
                {/* <BrowserRouter>
                    <React.Fragment>
                        <Routes>
                            {routes.map((route, index) => {
                                return (
                                    <route.route
                                        key={index}
                                        path={route.path}
                                        exact={route.exact}
                                        roles={route.roles}
                                        component={withLayout(props => {
                                            const Layout = this.getLayout(route.name);
                                            return (
                                                <Suspense fallback={loading()}>
                                                    <Layout {...props}>
                                                        <route.component {...props} />
                                                    </Layout>
                                                </Suspense>
                                            );
                                        })}
                                    />
                                );
                            })}
                            <Route component={NotFound} />
                        </Routes>
                    </React.Fragment>
                </BrowserRouter>
            </div> */}

            
                <BrowserRouter>
                <NavigationProvider>
                {/* <AuthLayout />  */}

                    <React.Fragment>
                        <Routes>

                            {routes.map((route, index) => {
                                const Layout = this.getLayout(route.name);
                                return (
                                    <Route
                                        key={index}
                                        path={route.path}
                                        element={
                                            <Suspense fallback={loading()}>
                                                <Layout>
                                                    <route.component />
                                                </Layout>
                                            </Suspense>
                                        }
                                    />
                                );
                            })}
                            <Route path="*" element={<NotFound />} />
                        </Routes>
                    </React.Fragment>
                    </NavigationProvider>
                </BrowserRouter>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isAuthenticated: state.Auth.isAuthenticated
    }
}

export default connect(mapStateToProps, null)(App);

